import React from "react";
const ErrorMessage = (props) => {
  return (
    <div style={{ marginTop: "2%" }} role="alert">
      <p>{props.content}</p>
      <p>If the problem persists, please contact g.zupanc@northeastern.edu</p>
    </div>
  );
};
export default ErrorMessage;
